module.exports = __webpack_public_path__ + "img/AE.34c24f48.svg";